import { Injectable } from "@angular/core";
import { DateService } from "@root/shared/service/date.service";
import { InternationalService } from "@root/international.service";
import _ from "lodash";

interface QuarterValue {
  year: number | string;
  quarter: number | string;
}
@Injectable()
export class TranslateQuarterService {
  constructor(
    private dateService: DateService,
    private internationalService: InternationalService
  ) {}

  getQuarterFormated(value: QuarterValue) {
    const isInternational = this.internationalService.isInternational();
    if (!isInternational) {
      return this.formatValue(value, 0);
    }
    const dateFormat = this.dateService.getDateFormat();
    const fValue = [
      [0],
      [1],
      [10],
      [11, 12, 13, 14, 15],
      [2, 3, 16, 4, 6, 7, 17, 8],
    ];
    for (let i = 0; i < fValue.length; i++) {
      const index = _.indexOf(fValue[i], dateFormat);
      if (index !== -1) {
        return this.formatValue(value, i);
      }
    }
    return this.formatValue(value, 0);
  }

  formatValue(value: QuarterValue, index) {
    switch (index) {
      case 0:
        return `${value.year}-Q${value.quarter}`;
      case 1:
        return `${value.year}/Q${value.quarter}`;
      case 2:
        return `${value.year}.Q${value.quarter}`;
      case 3:
        return `${value.year} Q${value.quarter}`;
      case 4:
        return `Q${value.quarter} ${value.year}`;
    }
  }
}
